var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-offer-buttons",on:{"click":function($event){$event.stopPropagation();}}},[_c('ShareButtons',{attrs:{"networks":_vm.networks,"shareData":{
      title: _vm.offer.title,
      text: _vm.description,
      url: _vm.offer.branchLink,
      image: _vm.offer.picture
    }},on:{"open":function($event){return _vm.$emit('social-network-clicked', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }